import React from 'react'
import PropTypes from 'prop-types';

export default function FieldLabel({ field, showLabel }) {
  if (!showLabel) return null;

  return (
    <div className="display-inline-block">
      <label>
        {field.name}
        {field.required &&
          <span className="text-danger"> *</span>
        }
      </label>
    </div>
  )
}

FieldLabel.propTypes = {
  field: PropTypes.object.isRequired,
  showLabel: PropTypes.bool.isRequired
}
